import { Component, OnInit, Injectable} from '@angular/core';
import {
  NgbCalendar,
  NgbDateAdapter,
  NgbDateStruct,
  NgbDate
} from '@ng-bootstrap/ng-bootstrap';

import { FormGroup, FormControl, Validators} from '@angular/forms';
import { AppointmentsService } from 'src/app/services/appointments.service';
import { ClientsService } from 'src/app/services/clients.service';
import { Subject } from 'rxjs';
import * as moment from 'moment';
import { switchMap } from 'rxjs/operators';
import { DatosService } from 'src/app/clients/servicios/datos.service';

@Injectable()
export class CustomAdapter extends NgbDateAdapter<string> {
  readonly DELIMITER = '-';

  fromModel(value: string): NgbDateStruct {
    let result: NgbDateStruct = null;
    if (value) {
      let date = value.split(this.DELIMITER);
      result = {
        day : parseInt(date[0], 10),
        month : parseInt(date[1], 10),
        year : parseInt(date[2], 10)
      };
    }
    return result;
  }

  toModel(date: NgbDateStruct): string {
    let result: string = null;
    if (date) {
      result = date.day + this.DELIMITER + date.month + this.DELIMITER + date.year;
    }
    return result;
  }
}

@Injectable()
export abstract class NgbDatepickerI18n {
  abstract getWeekdayShortName(weekday: number): string;
  abstract getMonthShortName(month: number): string;
  abstract getMonthFullName(month: number): string;
  abstract getDayAriaLabel(date: NgbDateStruct): string;
}

@Component({
  selector: 'app-schedule',
  templateUrl: './schedule.component.html',
  styleUrls: ['./schedule.component.scss']
})
export class ScheduleComponent implements OnInit {
  _ngbDate: NgbDateStruct;
  public clients = [];  
  public displayForm = false
  public appointmentForm: FormGroup;
  public submitted = false;
  public isEditForm = false;
  public appointments = [];
  private now = null;
  private monthObs = new Subject<String>();
  private dateObs = new Subject<moment.Moment>();
  private today;
  public showAppointment = false;
  public selectedAppointment = null;
  items = [];
  pageOfItems: Array<any>;

  isDisabled = (date: NgbDate, current: {month: number}) => this.calendar.getWeekday(date) === 7;
  isWeekend = (date: NgbDate) =>  this.calendar.getWeekday(date) >= 6;
  
  constructor(private calendar: NgbCalendar, private appointmentsService : AppointmentsService, 
    private clientsService : ClientsService, private _dataService: DatosService) {
  }

  public services = this._dataService.services
  public selectedServices = [];
  public desplegado = false

  selectService(service){
    let posicion = this.selectedServices.findIndex(s => s.id === service.id)
    if( posicion === -1 ){
      this.selectedServices.push(service)
    }else{
      this.selectedServices.splice( posicion , 1)
    }
  }
  desplegarSelect(){
    this.desplegado = !this.desplegado
  }

  ngOnInit() {
    this.today = moment().startOf('day');
    moment.locale('custom-es', {
      parentLocale: 'es'
    });
    this.appointmentForm = new FormGroup ({
      'id': new FormControl(''),
      'first_name': new FormControl('', [Validators.required]),
      'surname': new FormControl('', []),
      'email': new FormControl('', []),
      'phone': new FormControl('', [Validators.required]),
      'selectedDate': new FormControl(new Date(),[Validators.required])
    })
    let clientSub = this.dateObs.pipe(
      switchMap(date => 
        this.appointmentsService.getAppointmentsByDate(date)
      )
    )
    clientSub.subscribe((appointmentsnapshot) => {
      this.appointments = [];
      appointmentsnapshot.forEach((providerData: any) => {
        this.appointments.push({
          id: providerData.payload.doc.id,
          data: providerData.payload.doc.data()
        });
      })
    });
    let birthdaySub = this.monthObs.pipe(
      switchMap(month => 
        this.clientsService.getClientsByBirthday(month.toString())
      )
    )
    birthdaySub.subscribe((clientsnapshot) => {
      this.clients = [];
      clientsnapshot.forEach((clientData: any) => {
        this.clients.push(Object.assign(
          {id: clientData.payload.doc.id},
          clientData.payload.doc.data()
        ));
      })
    });
    this.selectToday();
  }

  onChangePage(pageOfItems: Array<any>) {
    this.pageOfItems = pageOfItems;
  }

  selectToday() {
    this.now = moment();
    this._ngbDate = this.calendar.getToday();
    this.monthObs.next(this.now.locale("en").format("MMM"));
    this.now.locale(false);
    this.dateObs.next(this.now);
  }
  
  AddNewAppointment() {
    const formElement = document.querySelector("#appointment-form");
    if (formElement) formElement.scrollIntoView({ behavior: 'smooth', block: 'end' })
    this.onReset();
    this.displayForm = true;
  }

  editAppointment(appointment){
    const formElement = document.querySelector("#appointment-form");
    if (formElement) formElement.scrollIntoView({ behavior: 'smooth', block: 'end' })
    this.onReset();
    this.appointmentForm.patchValue({id: appointment.id, ...appointment.data});
    this.f.selectedDate.patchValue(appointment.data.selectedDate.toDate());
    this.selectedServices = Object.assign([], appointment.data.services);
    this.displayForm = true;
    this.isEditForm = true;
  }

  viewAppointment(appointment){
    const formElement = document.querySelector("#appointment-show");
    if (formElement) formElement.scrollIntoView({ behavior: 'smooth', block: 'end' })
    this.onReset();
    this.showAppointment = true;
    this.selectedAppointment = appointment;
  }

  deleteAppointment(){
      this.appointmentsService.deleteAppointment(this.f.id.value);
      this.onReset()
    }

  onSubmit(){
    this.submitted = true;
    if (this.appointmentForm.valid){
      let formData = Object.assign({}, this.appointmentForm.value);
      formData['services'] = this.selectedServices;
      formData['status'] = 'Confirmado';
      if (this.isEditForm) {
        this.appointmentsService.updateAppointment(formData)
        .then(() => {
          this.onReset()
        })
      }
      else {
        this.appointmentsService.createAppointment(formData)
        .then(() => {
          this.onReset()
        })
      }   
    }
  }

  onReset(){
    this.submitted = false;
    this.appointmentForm.reset();
    this.displayForm = false;
    this.isEditForm = false;
    this.selectedServices = [];
    this.showAppointment = false;
    this.selectedAppointment = null;
  }

  get f(){
    return this.appointmentForm.controls;
  }

  get formSubmitValue(){
    if (this.isEditForm) {
      return "Confirmar Cita"
    }
    else {
      return "Añadir Cita"
    }
  }

  get editableAppointments() {
    return this.now >= this.today;
  }

  get minDate(){
    let today = new Date;
    let dd = String(today.getDate()).padStart(2, '0');
    let mm = String(today.getMonth() + 1).padStart(2, '0'); //January is 0!
    let yyyy = today.getFullYear();
    return `${yyyy}-${mm}-${dd}`;
  }

  get minNgbStruct(){
    let today = new Date;
    let dd = today.getDate();
    let mm = today.getMonth() + 1;
    let yyyy = today.getFullYear();
    return {day: dd, month: mm, year: yyyy}
  }

  onDateSelection(date: NgbDate) {
    this.now = moment.utc(`${date.year}-${date.month}-${date.day}`);
    this.monthObs.next(this.now.locale("en").format("MMM"));
    this.now.locale(false);
    this.dateObs.next(this.now);
  }

  public get displayNow(){
    return this.now.format("MMMM - DD");
  }

  public isServiceSelected(service) {
    return this.selectedServices.filter(s => s.id === service.id).length > 0;
  }

  public displaySelectedDate(date) {
    return moment(date).format("dddd, HH:mm")
  }

  public displayServicesList(services) {
    return services.map(service => `<strong>${service.type}</strong>: ${service.service}`).join(" - ");
  }

}
